export interface CardContent {
  name1: string;
  description1: string;
  name2: string;
  description2: string;
  name3: string;
  description3: string;
  icon: string;
}

export interface DailyTipContent {
  symbol: string;
  message: string;
  moon_phase: string;
  symbol_description: string;
}

export interface ArcanaContent {
  arcana: number;
  cellIndex: number;
  arcanaName: string;
  arcanaDescription: string;
  storyData: ArcanaStoryData[];
  cellTitle: string;
  icon: string;
}

export interface ArcanaStoryData {
  title: string;
  descriptions: string;
}

export enum ContentTagType {
  CARD = 'Card',
  RANDOM_CARDS = 'RandomCards',
  DAILY_TIP = 'DailyTip',
  SUPER = 'Super',
  /** Matrix content depends on user gender; invalidate when profile (gender) changes */
  MATRIX = 'Matrix',
}
